// libraries, constants and class definitions
import * as createjs from "createjs-module";
import * as symConst from 'src/app/shared/constant/canvasSymTypes'; 
import { COMMON_KEYS, MATH_KEYS } from 'src/app/shared/constant/math-keys';
import {DISPLAY_TYPE_GRID, DISPLAY_TYPE_LINE, IMAGE_TYPE_NONE , IMAGE_TYPE_PDF ,IMAGE_TYPE_BITMAP,
  MathFileProbType , MathFileType, NO_DATA_TO_SAVE,MPROB_NEW_LINE,
  SIZE, MPROB_NEW_LINE ,FULL_CANVAS, UserInputLog, userLog, ONE_PAGE_LENGTH,
  MathFileSpecSym,CREATEJS_NAME_CARRY_TEXT, DISPLAY_TYPE_TEXT,FONT_INDEX,
  undoStackType,CREATEJS_NAME_IMPORT_FILE,WhiteSpaceSize,
  MathFilePenItem,PenItemType} from 'src/app/shared/constant/drawConstants';
import {STATE_NORMAL, STATE_FILE_IMPORT, STATE_OPEN_FILE,STATE_INIT,STATE_IN_IPAD_ABC, KEY_ID_ALT_E,
    SCALE_INCREMENT,MProbType, MLineType,OVERLAY_TYPE_LINE, STATE_IN_PEN_TOOL, STATE_VIEW_ONLY_FILE,
    SymbolType,SymbolLong,SymbolSimple} from 'src/assets/js/cv-classes.js'
import {setDrawObjToDefault, initPen, drawSavedPenItem} from 'src/assets/js/cv-pen-tool.js';

// functions and variables from other files
import {db,stage,draw,cvControl,notifySideboardLev3Mode,clearProbState} from 'src/assets/js/draw.js';
import {displayTextFileOpen} from 'src/assets/js/cv-text.js';
import {drawPageBreakLine, setStageBackground,drawPageBreakLine, drawCursor,  
        makeProbSelected,ifIpadAddStageContainer} from 'src/assets/js/cv-graphics-mouse.js';
import {startMProb} from 'src/assets/js/cv-layout-shared.js';
import {displaySpecialSymFileOpen,spliceOneNullSym} from 'src/assets/js/cv-grid-entry.js';
import {newTreeSym} from 'src/assets/js/cv-line-entry.js';
import {findProbEndX, findProbEndY, resetTreeXYPosAndCursor, hideCursor,
  movePenLayerBehindMath} from 'src/assets/js/cv-helpers.js';
import {updateSavedImagesForPriorSplits} from 'src/assets/js/cv-whitespace.js';


export function cvHandleGetFileData(undoObj) {

  let mProb, mathFile, specSym, carryText;
  let count = -1;
  let line;
 //console.log("handleGetFileData");
  //if (db.fileChanged || db.mProb.length == 0) {     // check that there is something for the file to update

    // create a math file object to pass on

    if (db.probState == STATE_IN_IPAD_ABC) {
      //clearProbState();
    }
   
    let scale = (db.mProb.length == 0) ? 1 : stage.scaleX; 
    mathFile = new MathFileType(db.mathLevel,scale,DISPLAY_TYPE_GRID,db.imageScale);

    mathFile.pageCount = db.pageCount;   

    // save problem count for analytics reporting
    if (db.mProb != null) {
      mathFile.problemCount += db.mProb.length;
    }
    if (db.penItemList != null) {
      mathFile.problemCount += db.penItemList.length;
    }

    // for each problem, add the problem data
    for (let i = 0; i < db.mProb.length; i++) {
    
      mProb = db.mProb[i];
      
      if (!mProb.deleted) {
        count++;

        let fileProb = new MathFileProbType(mProb.displayType,mProb.xpos,mProb.ypos,
                    mProb.probScale,mProb.fontSize, mProb.fontIndex, mProb.gridW, mProb.gridH,mProb.width);
             
        // for each line within the problem, go through each line and 
        // push to the fileProb the user entered symbols
        for (let j = 0; j < mProb.line.length; j++) {
          //console.log("each save line", mProb.line[j],db.curProb.displayType,db.curProb.displayType == DISPLAY_TYPE_LINE);
          line = mProb.line[j];
          saveOneLine(mProb,line,fileProb);

          // at the end of a line,if there are additional lines, add a new line
          if (j < mProb.line.length-1) {
            fileProb.data.push(MPROB_NEW_LINE);
          }
        }
        mathFile.mathProblem.push(fileProb);
      }
      // watch for the current problem, and adjust the undo stack pIndex for any deleted problems
      if (i == db.pIndex && undoObj != null) {
        undoObj.pIndex = count;
      }
    }

    // check for and save an draw tool items
    if (db.penItemList != null) {
      let newPenItem;
      for (let i = 0; i <= db.penItemList.length-1; i++) {
        if (!db.penItemList[i].deleted) {
          newPenItem = new MathFilePenItem();
          newPenItem.copyForFileSave(db.penItemList[i])
          mathFile.savedPenItem.push(newPenItem);
        }
      }
    }
    
  //}
  
  //else {      // if nothing needs updating then return a null
  //  mathFile = NO_DATA_TO_SAVE;
  //}

  // save data on image soureRect locations if there have been any whitespace splits 
  if (db.hasSplits) {
    let nextWhiteSpace;
    for (let i = 0; i < db.imageSourceFromSplits.length; i++) {
      nextWhiteSpace = new WhiteSpaceSize(db.imageSourceFromSplits[i].startY,
            db.imageSourceFromSplits[i].height, db.imageSourceFromSplits[i].originalImgIndex,
            db.imageSourceFromSplits[i].priorImgIndex,db.imageSourceFromSplits[i].imageY);
      mathFile.whiteSpaceSplits.push(nextWhiteSpace);
    }
    
  }

  
 //console.log("save file", db.state, mathFile);
  //console.log("math file to save", mathFile.savedPenItem.length, mathFile);
  return(mathFile);
  
}

export function saveForCopyDuplicate(line,startSIndex, endSIndex) {

  let mProb, mathFile,specSym;

  mathFile = new MathFileType(db.mathLevel,stage.scaleX,db.curProb.displayType,db.imageScale);
  mathFile.pageCount = db.pageCount;
    
  mProb = db.curProb;

  let fileProb = new MathFileProbType(mProb.displayType,mProb.xpos,mProb.ypos,
                    mProb.probScale,mProb.fontSize, mProb.fontIndex, mProb.gridW, mProb.gridH,mProb.width);

  if (db.curProb.displayType == DISPLAY_TYPE_TEXT) {
   
      specSym = new MathFileSpecSym(symConst.KEY_ID_ABC,line.sym[0].w,
      line.sym[0].h, line.sym[0].textTyped,
      line.sym[0].wrapStarted);
      fileProb.data.push(specSym);  
  }               
  else {          
    saveOneLine(mProb,line,fileProb,startSIndex,endSIndex);
  }
  mathFile.mathProblem.push(fileProb);
  
  return(mathFile);
}


/*
* function saveOneLine saves one line of a problem to the fileProb for storage.   
* Is called by either cvHandleGetFileData for save and undo saving,
* or to handle saving a line or part of a line to internal clipboard or for line duplication
* startIndex and EndIndex are indexes into symbol array, not SIndexes
*/

function saveOneLine(mProb,line,fileProb,startIndex,endIndex) {

  let specSym, carryText;
  let inCopy = (startIndex != null) && (endIndex != null);
  
  //let keyID;
  //let keyGroupInfo = MATH_KEYS[keyID]?.commonkeyGroup;
  //let groupAndType = COMMON_KEYS[keyGroupInfo];

    if (mProb.displayType == DISPLAY_TYPE_LINE) {
      branchGetFileData(line, fileProb,startIndex,endIndex);
    }
    else {
      //console.log("start not line prob", mProb, mProb.displayType);
      // check if passed in a start and end sIndex - this is does only for a clipboard
      // copy, in which case only copy the range specified
      let tempSIndex = db.curLine.sIndex;
      let start = (startIndex == null) ? 0 : startIndex;
      let end = (endIndex == null) ? line.sym.length : endIndex;   // CHECK THESE RANGES
   
      for (let symIndex = start; (symIndex < end && symIndex < line.sym.length); symIndex++) {
      

        // check for and repair errors in internal data structures, but putting null string object in
        // if find undefined grid element
        if (line.sym[symIndex] == null) {
          line.sym[symIndex] = new SymbolSimple(symConst.CV_EMPTY_SYM, symConst.CV_EMPTY_SYM);
          //console.log("fixed curProb error in ", db.curLine, "posiition ", symIndex);

        }
      
        // check if this symbol was actually an ABC text, and save it differently
        if (line.sym[symIndex].type == symConst.KEY_ID_ABC) {
    
          specSym = new MathFileSpecSym(symConst.KEY_ID_ABC,line.sym[symIndex].w,
            line.sym[symIndex].h, line.sym[symIndex].textTyped,
            line.sym[symIndex].wrapStarted);
          fileProb.data.push(specSym);
      
        }
        else if (line.sym[symIndex].str == symConst.KEY_ID_FRACTION_GRID_SIGN) {
          specSym = new MathFileSpecSym(symConst.KEY_ID_FRACTION_GRID_SIGN,db.curProb.gridW,
            db.curProb.gridH, line.sym[symIndex].fractionNumStr,
            false,line.sym[symIndex].fractionDenStr);
            //console.log("write object", specSym, line.sym[symIndex].fractionDenStr);
          fileProb.data.push(specSym);

        }
        // otherwise just push symbol normally
        else {
          fileProb.data.push(line.sym[symIndex].str);
        }
        // since cross-offs are on top of symbols, have to do special things to save them
        // if there are carry digits then push them also after the symbol type with a cntl_complete
        // this replicates the user actions to create this symbol
        if (line.sym[symIndex].crossOff != null) {
          //console.log("type",line.sym[symIndex].crossOffType,line.sym[symIndex] );
          let type = line.sym[symIndex].crossOffType;
          fileProb.data.push(line.sym[symIndex].crossOffType);

          if (type == symConst.KEY_ID_CROSSOFF_2 || type == symConst.KEY_ID_CROSSOFF_3 ) {
            carryText = line.sym[symIndex].crossOff.getChildByName(CREATEJS_NAME_CARRY_TEXT);
            // if no carry entered, then add complete to move out of crossoff state when open file or undo
            if (carryText == null || carryText.length == 0) {
              fileProb.data.push(symConst.CV_CNTL_COMPLETE);
            }
            else {
              fileProb.data.push(carryText.text[0]);
              if (carryText.text.length == 1) {
                fileProb.data.push(symConst.CV_CNTL_COMPLETE);
              }
              else {
                fileProb.data.push(carryText.text[1])
              }
            }
          }
        
        }
      }

      // FIX THESE FOR CLIPBOARD COPY
      // if there is an overlay (line,divide) then add that to the problem
      // not supported yet- multiple overlays in a line
      // if in copy to clipboard, only copy region selected
      for (let k = 0; k < line.overlayDiv.length; k++ ) {
        if (!inCopy || startIndex <= line.overlayDiv[k].start) {
        specSym = new MathFileSpecSym(line.overlayDiv[k].type,line.overlayDiv[k].start,
                                      line.overlayDiv[k].end);
       
        
        // if a clipboard copy, then add in the last problems sIndex since could be
        // shifting over the division                              
        if (inCopy) {
          specSym.size1 = line.overlayDiv[k].start - (startIndex);// + (tempSIndex+1);
          specSym.size2 = Math.min(line.overlayDiv[k].end,endIndex) - startIndex;// + (tempSIndex+1);
        }
        fileProb.data.push(specSym);
        }
      }

      // skip copying the line if this is a copy for a paste, since line segment doesn't appear as part of 
      // the line to a user
      /*
      if (line.overlayLine != null && !inCopy) {
        specSym = new MathFileSpecSym(line.overlayLine.type,line.overlayLine.start,
                                      line.overlayLine.end);
        fileProb.data.push(specSym);
      }
      */
      let symIndex = start;
      let symStart;
      let symEnd = 0;
      while (symIndex <= end && symIndex < line.sym.length) { 
        if (line.sym[symIndex].lineSegStart != null ||
            symIndex == start && line.sym[symIndex].lineSeg != null) {
              symEnd = symIndex;
              symStart = symIndex;
              while (symEnd < line.sym.length && symEnd <= end && line.sym[symEnd].lineSegEnd == null) {
                symEnd++;
                symIndex = symEnd;
              }
              specSym = new MathFileSpecSym(OVERLAY_TYPE_LINE,symStart,
                  symEnd);
              fileProb.data.push(specSym);
              //console.log("pushed line", symIndex);
        }
        symIndex++;
      }
     

    }  // end grid or text type
    
}
 


/**
 * recursive routine!
 * function branchGetFileData will save to the problem file structure one branches worth of symbols, including
 * branches off the passed one, by calling itself recursively.  Called first time pass main line as the branch
 * Traverses line problem trees
 */
function branchGetFileData(branch, fileProb,startIndex,endIndex) {

  let waitComplete = false;
  let specSym;
  if (branch.sym[0] != null) {
    //console.log("start branchfile", branch.sym[0].str, branch);
  }
  let start = (startIndex == null ? 0 : startIndex);
  let end = (endIndex == null ? branch.sym.length-1 : endIndex);  

  for (let symIndex = start; (symIndex <= end && symIndex <= branch.sym.length-1); symIndex++) {

    
    // if waitComplete was set by a prior branch symbol, then push the complete
    // this needs to not be done right after the branch symbol to make undo cursor positions work right
    //if (waitComplete) {
    //  fileProb.data.push(symConst.CV_CNTL_COMPLETE);
    //  waitComplete = false;
    //}
    // check if this symbol was actually an ABC text, and save it differently
    if (branch.sym[symIndex].type == symConst.CV_TEXT_TO_LINE) {
        specSym = new MathFileSpecSym(symConst.KEY_ID_ABC,branch.sym[symIndex].width,
        db.curProb.gridH*db.curBranch.bScale, branch.sym[symIndex].str,
        false);
      fileProb.data.push(specSym);
    }
    else {
      if (branch.sym[symIndex].str == symConst.KEY_ID_E && branch.sym[symIndex].altStr == true) {
        fileProb.data.push(branch.sym[symIndex].alt);
      }
      else {
        // if space created with arrow key (for overwrite, then substitute a null symbol to save)
        if (branch.sym[symIndex].str == symConst.KEY_ID_SPACE && branch.sym[symIndex].type == symConst.CV_NUM_TYPE) {
          fileProb.data.push(symConst.CV_EMPTY_SYM);
        }
        // remove limit sign arrows and push every thing else
        else if (branch.sym[symIndex].str != symConst.KEY_ID_LIMIT_ARROW) {
          fileProb.data.push(branch.sym[symIndex].str);
        }
      }
    
      // call crossoff routine to push them if found a cross-off
      if (branch.sym[symIndex].crossOff != null) {
        pushCrossOffToSaveFile(branch,symIndex,fileProb); 
      }
    
      if (branch.sym[symIndex].groupCode == symConst.CV_BRANCHING_GRP) {
      
        for (let i = 0; i <= branch.sym[symIndex].branchCount-1; i++ ) {
          if(branch.sym[symIndex].branch[i].sym.length > 0) {
            //if (waitComplete) {
            // fileProb.data.push(symConst.CV_CNTL_COMPLETE);
            //  waitComplete = false;
            //}
            branchGetFileData(branch.sym[symIndex].branch[i], fileProb);
            //if (!branch.sym[symIndex].branch[i].needComplete) {
       
              fileProb.data.push(symConst.CV_CNTL_COMPLETE);
            
           // }
            //waitComplete = true;
          
          }
          else {
            fileProb.data.push(symConst.CV_CNTL_COMPLETE);
          }
        }
      }

    }
  }
}

/**
 * function pushCrossOffToSaveFile saves the cross-off symbols to a save file
 * called from above recursive routine, seperated for understandability
 */

function pushCrossOffToSaveFile(branch,symIndex,fileProb) {

  let carryText;
  let type = branch.sym[symIndex].crossOffType;
  fileProb.data.push(branch.sym[symIndex].crossOffType);

  if (type == symConst.KEY_ID_CROSSOFF_2 || type == symConst.KEY_ID_CROSSOFF_3 ) {
    carryText = branch.sym[symIndex].crossOff.getChildByName(CREATEJS_NAME_CARRY_TEXT);
    // if no carry entered, then add complete to move out of crossoff state when open file or undo
    if (carryText == null || carryText.length == 0) {
        fileProb.data.push(symConst.CV_CNTL_COMPLETE);
    }
    else {
      fileProb.data.push(carryText.text[0]);
      if (carryText.text.length == 1) {
        fileProb.data.push(symConst.CV_CNTL_COMPLETE);
      }
      else {
         fileProb.data.push(carryText.text[1])
      }
    }
  }

}




export function cvOpenFile(mathFile,fromUndo,undoObj) {

 
  // recreate the db data structures from the mathFile contents
  // start by saving the canvas level values
  //console.log("start open file", mathFile);
    
  db.state = STATE_OPEN_FILE;
  //console.log("level from within math file", mathFile.mathLevel);
  //let keyGroupInfo;
  //let groupAndType;
  let priorScale = stage.scaleX;
 
  // temp to deal with old file formats
  if (mathFile.pageCount == null) {
    mathFile.pageCount = 1;
  }
  db.pageCount = mathFile.pageCount;
  stage.scaleX = stage.scaleY = mathFile.stageScale;
  // stage size has already been adjusted for the image size, so only add pages if needed
  // from the save file plus the scale - sideboard doesn't scale pages
  let stagePageCount = stage.canvas.height /(ONE_PAGE_LENGTH);

  // Add check to prevent past file corruption problem of pagecount geting set wrong to default
  // from autosave happening before file loaded, sets to at least the PDF length 
  // will not correct pageCount to include extra user added pages if this runs
  
  if (!fromUndo && (mathFile.pageCount < 3 && mathFile.pageCount < stagePageCount)) {
      mathFile.pageCount = db.pageCount = stagePageCount;
  }
 
  if (!fromUndo) {
    if (mathFile.pageCount > stagePageCount) {
      let addPage = mathFile.pageCount - stagePageCount; 
      stage.canvas.width = stage.canvas.width * mathFile.stageScale;
      stage.canvas.height = (stage.canvas.height + (ONE_PAGE_LENGTH * addPage)) * mathFile.stageScale;
    }
    else {
      stage.canvas.width = stage.canvas.width * mathFile.stageScale;
      stage.canvas.height = stage.canvas.height * mathFile.stageScale;
    }
    
  }
 
  //in the case of undo, can end up needing to decrease page count if undo was of a past a page add, 
  // so if undo page size is different than current, then reset to that. 
  
  else {
  
    
   if (undoObj != null && (undoObj.canvasWidth != stage.canvas.width || undoObj.canvasHeight != stage.canvas.height)) {
    stage.canvas.width = undoObj.canvasWidth;
    stage.canvas.height = undoObj.canvasHeight;
    }
  }
 
  // if jsonfile is over a certain version, take the math level from the jsonfile, to reduce error risk
  //if (mathFile.version >= 2.0 && !fromUndo) {
  //  db.mathLevel = mathFile.mathLevel;
  //}

  db.lastCanvasY = stage.canvas.height;
  db.imageType = mathFile.imageType;
  db.imageScale = db.imageScale;  
  //let nextStr,symObj;
  let mFileProb;
 // let abcCount = 0;

  if (mathFile.pageCount == null) {
    mathFile.pageCount = 1;
  }

  // check file for backward compatibility issue - add field if needed
  if (mathFile.whiteSpaceSplits == undefined) {
    mathFile.whiteSpaceSplits = []; 
  }

  // check for prior version files - backward compatibiity
  if (mathFile.savedPenItem == undefined) {
    mathFile.savedPenItem = [];
  }

  
  for (let i = 0; i < mathFile.mathProblem.length; i++) {
  
    mFileProb = mathFile.mathProblem[i];
    //console.log(mFileProb);
    
    // for each math problem stored, set x and y position in db to match the file, then
    // call cvNewProb to create a new problem data structure
    db.xpos = mFileProb.x;
    db.ypos = mFileProb.y;
    
    db.displayType = mFileProb.type;    
    
    // check for old version of file without fontIndex
  
    if (mFileProb.fontIndex == undefined) {
      mFileProb.fontIndex = db.fontIndex;  // this will not allow correct font increase but will prevent errors
    }
    
    //db.curProb.fontIndex = mathFile.fontIndex;
    //db.curProb.fontSize = mathFile.font;
    
    startMProb(mFileProb.type,mFileProb);
    db.curProb.probScale = mFileProb.pScale;
    db.curProb.widthFromFile = mFileProb.width;

    drawFromSaveFile(mathFile,mFileProb); 
    
    
  }
  // check for any copy the whitespaceSplits location info
  db.hasSplits = (mathFile.whiteSpaceSplits.length > 0);
  if (db.hasSplits && !fromUndo) {
    let nextSplit;
    for (let i = 0; i< mathFile.whiteSpaceSplits.length; i++) {
      nextSplit = new WhiteSpaceSize(mathFile.whiteSpaceSplits[i].startY, mathFile.whiteSpaceSplits[i].height, 
                                      mathFile.whiteSpaceSplits[i].originalImgIndex, mathFile.whiteSpaceSplits[i].priorImgIndex,
                                      mathFile.whiteSpaceSplits[i].imageY);
      db.imageSourceFromSplits.push(nextSplit);
    }
  }
  
  // check for and display an pen items
  //console.log("here open file penitem", mathFile, mathFile.savedPenItem.length-1);
  if (mathFile.savedPenItem.length > 0) {
    
    //cvControl(symConst.CV_CNTL_START_DRAW_TOOL);
    initPen();
    for (let i = 0; i <= mathFile.savedPenItem.length-1; i++) {
      drawSavedPenItem(mathFile.savedPenItem[i]);
      //console.log("hereC", mathFile.savedPenItem[i]);
    //cvControl(symConst.CV_CNTL_END_DRAW_TOOL); 
    }
     //console.log("after draw", db.penItemList.length, db.penItemList);
     movePenLayerBehindMath();
  }

  if (fromUndo && undoObj !=null) {
    db.pIndex = undoObj.pIndex;
  }

  db.state = STATE_NORMAL;
  // make the last problem selected
  if (db.pIndex >= 0 && !fromUndo && !db.inOpenViewOnly) {
    
    setLastProbActive();
  }
  

  if ((fromUndo && undoObj != null && undoObj.state == STATE_IN_PEN_TOOL) ||
      db.inOpenViewOnly) {
    hideCursor();
  }
  // if there are multiple pages, then draw page break
  for (let k = 1; k < db.pageCount; k++) {
    drawPageBreakLine((ONE_PAGE_LENGTH-5)*k);
  }

   stage.update();


  // Push an initial undo stack entry, so if user does whitespace add first, then have an undo obj for the current
  // math problems positions
  /*
  if (!fromUndo) { //} && db.mProb.length > 0) {
    // create an undo record for these 
    //db.fileChanged = true;
    cvGetDataUndoPush();
  }
    */
  
  //db.state = STATE_NORMAL;

  
}


export function setLastProbActive() {

  let lastIndex;
  for (lastIndex = db.pIndex; lastIndex >= 0 && !db.mProb[lastIndex].matchLevel; lastIndex--)  {
    // in case level was changed for file, find last editable or text problem
  }

  db.pIndex = lastIndex;
  if (lastIndex >= 0 && db.curProb.displayType != DISPLAY_TYPE_TEXT) {
    makeProbSelected(db.pIndex);
  }
  // if last problem was text or no editable problems, then create another blank problem to edit in after that
  else {
    // set to last problem temporarily to set positions, etc. 
    makeProbSelected(db.mProb.length-1);
    // reset the display type based on math level to default for the level
    db.displayType = (db.mathLevel == 1 || db.mathLevel == 2) ? DISPLAY_TYPE_GRID : DISPLAY_TYPE_LINE; 
    db.xpos = db.curProb.xpos;
    db.ypos = db.curProb.ypos;
    cvControl(symConst.CV_CNTL_NEW_PROBLEM);
  }
 
  if (db.curProb.displayType == DISPLAY_TYPE_GRID) {
  drawCursor(findProbEndX(db.curProb)+db.curProb.xpos-db.curProb.halfGW, 
                findProbEndY(db.curProb)+db.curProb.ypos-db.curProb.halfGH);
  }
  else {
    resetTreeXYPosAndCursor();
  }

  if (db.mathLevel == 3 && db.curProb.displayType == DISPLAY_TYPE_GRID) {
    notifySideboardLev3Mode(DISPLAY_TYPE_GRID); 
  }
}

export function drawFromSaveFile(mathFile,mFileProb) {

let keyGroupInfo;
let groupAndType;
let nextStr,symObj;
//let mFileProb;
let abcCount = 0;

 // for each data element in this problem, display that element
  for (let j = 0; j < mFileProb.data.length; j++) {

    // special symbols that need seperate processing are stored as objects
    if (typeof mFileProb.data[j] == "object") {
     
      symObj = mFileProb.data[j];
      if (symObj.symType == symConst.KEY_ID_ABC) {
        if (db.curProb.displayType == DISPLAY_TYPE_LINE) {
          newTreeSym(symObj.value,symConst.CV_LONG_GRP,symConst.CV_TEXT_TO_LINE,symObj.size1);
        }
        else { 
          displayTextFileOpen(symObj,mFileProb);
          abcCount = symObj.size1/db.curProb.gridW -1;
        }
      }
      else {
        // this draws both grid fractions and overlays
        displaySpecialSymFileOpen(symObj);
      }
    }
    
    else {
      nextStr = mFileProb.data[j];
      if (nextStr == MPROB_NEW_LINE) {
    
        cvControl(symConst.CV_CNTL_ENTER);
      
      }
      else if (nextStr == symConst.CV_CNTL_COMPLETE) {
        cvControl(nextStr);
      }   
      // if have a crossoff, then need to move to prior grid square for the crossoff symbol, and then
      // move back if it's a crossoff_1.  crossoff_2 and 3 will get positions advanced by completes after carry digits
      else if (nextStr == symConst.KEY_ID_BLUE_CROSSOFF_1 || nextStr == symConst.KEY_ID_BLUE_CROSSOFF_2 ||
                nextStr == symConst.KEY_ID_CROSSOFF_1 || nextStr == symConst.KEY_ID_CROSSOFF_2 ||
                nextStr == symConst.KEY_ID_CROSSOFF_3) {
        db.curLine.sIndex--;
        db.xpos -= db.curProb.gridW;
    
        draw(nextStr,symConst.CV_SPEC2_GRP,symConst.CV_CROSSOFF_TYPE);
        if (nextStr == symConst.KEY_ID_CROSSOFF_1 ) {
          db.curLine.sIndex++;
          db.xpos += db.curProb.gridW;
        }
      }
      else {

        // check for placeholder null symbol, to place special overwritable space symbol
        if (db.curProb.displayType == DISPLAY_TYPE_LINE && nextStr == symConst.CV_EMPTY_SYM) {
          draw(symConst.KEY_ID_SPACE, symConst.CV_SIMPLE_GRP,symConst.CV_NUM_TYPE);
        }
      
        else if (nextStr == symConst.CV_EMPTY_SYM && abcCount > 0) {

          draw(nextStr, symConst.CV_SIMPLE_GRP,symConst.CV_TEXT_FILL);
          //spliceOneNullSym(symConst.CV_TEXT_FILL);
          //let newSym = new SymbolSimple(symConst.CV_EMPTY_SYM, symConst.CV_TEXT_FILL); // not sure what type to put here 
          //db.curLine.sym.splice(db.curLine.sIndex+1,0,newSym);
        // db.xpos += db.curProb.gridW;
          abcCount--;
        }

        else {// have a regular symbol, find it's group and type using structures borrowed from math-keys file
          
          // do some silly stuff to fix up natural log e different than keyboard e
          if (nextStr  == symConst.KEY_ID_E) {
            draw(nextStr, symConst.CV_SPEC2_GRP, symConst.CV_ABC_TYPE);
          }
          else {
            if (nextStr == KEY_ID_ALT_E) {
              nextStr = symConst.KEY_ID_E;
            }
       
            keyGroupInfo = MATH_KEYS[nextStr]?.commonkeyGroup;
            groupAndType = COMMON_KEYS[keyGroupInfo];

            // Calculus derivative symbols are broken into smaller pieces by canvas so need adjustment
           
            //console.log(groupAndType.group, groupAndType.type);
            // some keyboard keys don't have group/type defined, call them as keyboard type
            if (groupAndType ==null || groupAndType.group == undefined || groupAndType.type == undefined) {
        
              draw(nextStr, symConst.CV_SPEC2_GRP, symConst.CV_ABC_TYPE);
            }
            else if (groupAndType.type == symConst.CV_DERIVATIVE_TYPE) {
              adjustCalcGroups(nextStr,keyGroupInfo,groupAndType);
            }

            else { 
              draw(nextStr, groupAndType.group, groupAndType.type);
            }
          }
          abcCount = 0;
        }
      }
    
    }
  }

}

// Since canvas processes calculus symbols from the math keys by breaking them into smaller parts
// fractions, it uses symbols different then sideboard, so the sideboard created groupAndType structure
// needs fields adjusted
function adjustCalcGroups(nextStr,keyGroupInfo,groupAndType) {

  switch(nextStr) {
    case symConst.KEY_ID_DX:
    case symConst.KEY_ID_DY:
    case symConst.KEY_ID_DT:
    case symConst.KEY_ID_DER_D:
    case symConst.KEY_ID_DER_D_SQR:
      groupAndType.group = symConst.CV_LONG_GRP;
      break;
  }

}
export function cvUndoReset(mathFile) {
 
  // clear the canvas of any prior display
  stage.removeAllChildren();

  // clear away all the past problems and most db structures to rebuild it
  db.undoResetDrawingBoard();
  // if ipad add the stage drag container for scroll emulatation
  ifIpadAddStageContainer();

  //add back the image file
  if (db.inIpad) {
    db.stageDragContainer.addChild(db.fileImage);
  }
  else {
    stage.addChild(db.fileImage);
  }
  
  
  // stage scale and size handled in cvOpenFile

  // set initsize to the last problem size, as long as the last one wasn't undoed
  if (mathFile != null && mathFile.mathProblem.length > 0) {
    db.fontIndex = mathFile.mathProblem[mathFile.mathProblem.length-1].fontIndex;
    db.initSize(db.fontIndex)
  }
  

  // add userlog push for undo action

}

export function cvStartNewFile(mathLevel,importURL,bitmaps,fromCancel) {

  
    // clear the canvas of any prior display
    stage.removeAllChildren();
    //clear all data structures except font and grid sizes
    if (fromCancel) {
      db.undoResetDrawingBoard()
    
      if (db.userLog == null) {
        db.userLog = new UserInputLog(db.mathLevel,db.fontIndex);
      }
    }
    else {
      db.resetDrawingBoard();
      setDrawObjToDefault();
      db.userLog = new UserInputLog(db.mathLevel,db.fontIndex);
    }
    // if on ipad then add a drag container to stage to container everything
    // the stage background has to be added later to get it right size to match files
    ifIpadAddStageContainer();
 
    stage.scaleX = stage.scaleY = 1;  // reset stage scale if scaled for previous file

    // if a set of bitmaps from a pdf are passed in,then set the stage to equal the length of these pages
    if (bitmaps != null && bitmaps.length > 0) {
      db.pageCount = bitmaps.length;   
      stage.canvas.height = 1123 * db.pageCount;
    }
    else {
      stage.canvas.height = 1123;
    }
    stage.canvas.width = 796;
    db.lastCanvasY = stage.canvas.height;
    stage.update();
  
    // set the size back to the user pref last size
  
    db.initSize(db.prefFont);
    db.mathLevel = mathLevel;
    db.displayType = (mathLevel == 1 || mathLevel == 2) ? DISPLAY_TYPE_GRID : DISPLAY_TYPE_LINE;
    
    if ((importURL != null && importURL.length > 0) || bitmaps != null) {
      
      // set up a createjs container for file images here,
      // since multi-page pdfs can load at different times
      db.fileImage = new createjs.Container();
      db.fileImage.name = CREATEJS_NAME_IMPORT_FILE;
      // test if order ends up correct with different loading times
      if (db.inIpad) {
        db.stageDragContainer.addChild(db.fileImage);
      }
      else {
        stage.addChild(db.fileImage);
      }

      // if given an png/jpg url then set up the import file to display 
      if (importURL != null && importURL.length > 0) {    
        //db.state = CV_STATE_FILE_IMPORT;
        db.fileCountDown = 1;
        var img = new Image();
        img.addEventListener('load',handleFileImage);
        
        
        img.src = importURL;
      }
      // if given an array of bitmaps from a pdf, then display each one
      else if (bitmaps != null) {

        db.fileCountDown = bitmaps.length;
        for (let i=0; i < bitmaps.length; i++) { 
          var img = new Image();
          img.src = bitmaps[i];
          img.fileCount = i;  // save image number so know what position in canvas to put this image
          img.addEventListener('load',handlePDFFileImage);
        }
      } 
    }    
    //console.log("displayType",db.displayType);
  }

// When the import image file is done loading, then
// make createjs objects to hold it and save it to db
function handleFileImage(e) {
    
    var bitmap = new createjs.Bitmap(e.target);
    bitmap.x = bitmap.y = 0;
    bitmap.mouseEnabled = false;
    db.state = (db.inOpenViewOnly) ? STATE_VIEW_ONLY_FILE : STATE_NORMAL;
    db.fileCountDown--; 

    //adjust the grid width to be the alternate, narrower width for on images
    //db.gridWidth = SIZE[db.fontIndex].altWidth;

    // if this is a new file opened, and it is wider than the stage more than a few pixels, then 
    // scale it smaller to fit
    if (stage.scaleX == 1 && db.imageScale == 1 && e.target.width -20 > stage.canvas.width ) {
      bitmap.scaleX = bitmap.scaleY = db.imageScale =   stage.canvas.width / e.target.width;
    }
    else {
      bitmap.scaleX = bitmap.scaleY = db.imageScale;
    }

    db.bitmap[0] = bitmap;
  
    // only add to stage and create starting splits structure if not prior splits from image file
    if (!db.hasSplits) {
      let startLoc = new WhiteSpaceSize(0,ONE_PAGE_LENGTH,0,0,bitmap.y);
      db.imageSourceFromSplits[0] = startLoc; 
      db.fileImage.addChild(bitmap);
    }
    else {
      updateSavedImagesForPriorSplits(db.imageSourceFromSplits);
    }

    stage.update();
}


// When the import image file is done loading, then
// make createjs objects to hold it and save it to db
function handlePDFFileImage(e) {
  //console.log(db.displayType);
   
  var bitmap = new createjs.Bitmap(e.target);
  bitmap.x = 0;
  bitmap.y = (ONE_PAGE_LENGTH+1)*e.target.fileCount;
  bitmap.mouseEnabled = false;
  db.fileCountDown--; 

  //let index = e.target.fileCount;

  if (stage.scaleX == 1 && db.imageScale == 1 && e.target.width -20 > stage.canvas.width ) {
    bitmap.scaleX = bitmap.scaleY = db.imageScale =   stage.canvas.width / e.target.width;
  }
  else {
    bitmap.scaleX = bitmap.scaleY = db.imageScale;
  }
  
  
  // set state to normal only after the last image is display    
  if (e.target.fileCount == db.pageCount-1) {
    db.state = (db.inOpenViewOnly) ? STATE_VIEW_ONLY_FILE : STATE_NORMAL;

  }

  //db.fileImage[index] = new createjs.Container();
  //db.fileImage[index].name = bitmap.name = FULL_CANVAS;
  //db.fileImage[index].addChild(bitmap);
  //stage.addChildAt(db.fileImage[index],1);

  // temp - whitespace testing
  db.bitmap[e.target.fileCount] = bitmap;
  
  // only add to stage and create starting splits structure if not prior splits from image file
  if (!db.hasSplits) {
    let startLoc = new WhiteSpaceSize(0,ONE_PAGE_LENGTH,e.target.fileCount,e.target.fileCount,bitmap.y);
    db.imageSourceFromSplits[e.target.fileCount] = startLoc; 
    db.fileImage.addChild(bitmap);
  }

  // check if this was last file to load and if there are file splits to process
  if (db.fileCountDown == 0 && db.openedFile != null && db.hasSplits) {
    updateSavedImagesForPriorSplits(db.imageSourceFromSplits);
  }

stage.update();
 
}

 